(() => {
  if (window.samRestockSignupLoaded) return;
  window.samRestockSignupLoaded = true;

  // Delegation also handles the purchase section being replaced after a variant change.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-restock-form]')) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true' || form.dataset.subscribed === 'true' || !form.reportValidity()) return;

    const email = form.querySelector('[name="email"]');
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-restock-status]');
    const fallback = form.querySelector('[data-restock-fallback]');
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = 'Signing up…';
    status.textContent = '';
    status.removeAttribute('data-error');
    fallback.hidden = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(form.dataset.companyId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-10-15' },
        signal: controller.signal,
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Sam website restock signup',
            profile: { data: { type: 'profile', attributes: {
              email: email.value.trim(),
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
              properties: { sam_restock_updates: true, sam_restock_variant_id: form.dataset.variantId }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
        } })
      });
      if (!response.ok) throw new Error('Subscription was not accepted.');
      form.dataset.subscribed = 'true';
      email.readOnly = true;
      button.textContent = 'Request received';
      status.textContent = 'Thanks for signing up! If you receive a confirmation email, confirm your subscription to get restock updates.';
    } catch (error) {
      status.dataset.error = 'true';
      status.textContent = 'We couldn’t complete your signup. Please try again or use the signup page below.';
      fallback.hidden = false;
      button.disabled = false;
      button.textContent = 'Notify me';
    } finally {
      clearTimeout(timeout);
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
    }
  });
})();
